var _rect, _path, _path2, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 45,
    viewBox: "0 0 53 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75202,
    y: 36.9664,
    width: 5.85706,
    height: 5.85208,
    rx: 2.92604,
    transform: "rotate(-42.8489 3.75202 36.9664)",
    fill: "#0D3B70",
    stroke: "#0D3B70"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66133 33.3612L6.14903 32.3915C2.75301 25.9637 5.21077 17.9999 11.6386 14.6039L17.7004 11.4012C18.6378 10.906 19.7991 11.2644 20.2943 12.2017C20.7895 13.139 21.9508 13.4974 22.8881 13.0022L24.3432 12.2335C25.2805 11.7382 25.6389 10.5769 25.1437 9.63962C24.6485 8.7023 25.0069 7.541 25.9442 7.04578L37.5118 0.934234C38.4885 0.418244 39.6985 0.791674 40.2145 1.76831L44.2386 9.38498C44.7546 10.3616 44.3812 11.5716 43.4045 12.0876L35.959 16.0213L33.5857 17.4396C32.2843 18.2173 31.5012 19.6343 31.5351 21.15L31.6038 24.2152L31.6421 25.9214C31.6715 27.2344 31.6062 28.5478 31.4467 29.8515C31.0123 33.4028 28.8672 36.5167 25.7037 38.1881L24.4489 38.8507C18.0211 42.2467 10.0573 39.789 6.66133 33.3612Z",
    fill: "#E9FF70",
    stroke: "#0D3B70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2624 23.1319C26.0437 26.5034 24.7546 30.6805 21.3831 32.4618C18.0116 34.243 13.8345 32.9539 12.0532 29.5824C10.272 26.2109 11.5611 22.0338 14.9326 20.2525C18.304 18.4713 22.4812 19.7604 24.2624 23.1319Z",
    fill: "#0D3B70",
    stroke: "#E9FF70"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.5864,
    y1: 6.06182,
    x2: 17.0243,
    y2: 1.21241,
    stroke: "#0D3B70"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22.9942,
    y1: 5.49654,
    x2: 25.1478,
    y2: 0.452411,
    stroke: "#0D3B70"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17.6297,
    y1: 8.47774,
    x2: 12.1683,
    y2: 7.97355,
    stroke: "#0D3B70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractice);
export default __webpack_public_path__ + "static/media/Practice.d8f357c4e6243e91fb89f919aa442565.svg";
export { ForwardRef as ReactComponent };